export const LOCAL_STORAGE_LOCALE_KEY = 'Locale';

export const LOCALE = {
  EN: 'en',
  AR: 'ar',
};
